import React from 'react';
import { ReactComponent as Logo } from 'assets/images/rein_logo.svg';
import { Grid, Typography, useTheme } from '@mui/material';

const ImageFromCDN= () => {
	const theme = useTheme()
	if (!theme.palette.assetUrl) return (<>
		<Logo width={171} height={40}/>
		<Typography variant="body1" fontSize="10px" lineHeight="12px">Renters Insurance powered by Assurant®</Typography>
	</>);

	return (
		<Grid container spacing={6} justifyContent={"center"}>
			<Grid size={{md: 4, xs: 12}}>
				<img
					src={theme.palette.assetUrl}
					alt={'logo'}
					loading="lazy"
					style={{ width: '100%', height: 'auto', maxWidth: 107 }}
				/>
			</Grid>
			<Grid size={{md: 4, xs: 12}}>
				<Logo width={171} height={40}/>
				<Typography variant="body1" fontSize="10px" lineHeight="12px">Renters Insurance powered by Assurant®</Typography>
			</Grid>
		</Grid>
	);
};

export default ImageFromCDN;
